import {
  ArrowBack,
  AddShoppingCartRounded,
  Build,
  Paid,
  Score,
  ShoppingBasketRounded,
  TrendingUp,
} from "@mui/icons-material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TabPanel from "../../components/TabPanel";
import { Paper } from "../../components/Paper";
import { findOfferDetails } from "../../services/offers";
import { useStyles } from "./styles";
import { Analytics } from "./Analytics";
import { Categories } from "./Categories";

export function DetailsOffers() {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [activeView, setActiveView] = useState<number>(0);

  const details = useQuery(["details", params?.id], () =>
    findOfferDetails(Number(params?.id))
  );

  const handleChangeView = useCallback((view: number) => {
    setActiveView(view);
  }, []);

  const handleNavigateGoToBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <Stack spacing={4} className={styles.root}>
        <Stack direction="row" spacing={1}>
          <Tooltip placement="top" title="Voltar">
            <IconButton onClick={handleNavigateGoToBack}>
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Typography variant="h4">{location?.state["name"]}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Paper
            loading={details.isLoading}
            icon={<ShoppingBasketRounded color="primary" fontSize="large" />}
            label="Ticket médio"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(details.data?.visaoGeral[0]?.ticket_medio)}
            prefix="R$"
            decimals={2}
          />
          <Paper
            loading={details.isLoading}
            icon={<Build color="primary" fontSize="large" />}
            label="Investimento"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(details.data?.visaoGeral[0]?.investimento)}
          />
          <Paper
            loading={details.isLoading}
            icon={<Score color="primary" fontSize="large" />}
            label="Vendas"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(details.data?.visaoGeral[0]?.qtde_vendas)}
          />

          <Paper
            loading={details.isLoading}
            icon={<AddShoppingCartRounded color="primary" fontSize="large" />}
            label="Faturamento"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(details.data?.visaoGeral[0]?.faturamento)}
            prefix="R$"
            decimals={2}
          />

          <Paper
            loading={details.isLoading}
            icon={<Paid color="primary" fontSize="large" />}
            label="ROI"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(details.data?.visaoGeral[0]?.roi)}
            prefix="R$"
            decimals={2}
          />

          <Paper
            loading={details.isLoading}
            icon={<TrendingUp color="primary" fontSize="large" />}
            label="Margem"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(details.data?.visaoGeral[0]?.margem_percentual)}
            suffix="%"
            decimals={2}
          />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1}>
            <Button
              onClick={() => handleChangeView(0)}
              variant={activeView === 0 ? "contained" : "outlined"}
            >
              Analítico
            </Button>

            <Button
              onClick={() => handleChangeView(1)}
              variant={activeView === 1 ? "contained" : "outlined"}
            >
              Categorias
            </Button>
            <Button
              onClick={() => handleChangeView(2)}
              variant={activeView === 2 ? "contained" : "outlined"}
            >
              Produtos
            </Button>
          </Stack>
        </Stack>
        <TabPanel index={0} value={activeView}>
          <Analytics
            ageGroup={details.data?.faixaEtaria}
            day={details.data?.vendasDia}
            genre={details.data?.genero}
            hours={details.data?.vendasHora}
            store={details.data?.vendasLoja}
            loading={details.isLoading}
          />
        </TabPanel>
        <TabPanel index={1} value={activeView}>
          <Categories
            loading={details.isLoading}
            categories={details.data?.categorias}
          />
        </TabPanel>
        <TabPanel index={2} value={activeView}>
          <></>
        </TabPanel>
      </Stack>
    </>
  );
}
